import { render } from "./ReceiptPrinters.vue?vue&type=template&id=d9efcda6&ts=true"
import script from "./ReceiptPrinters.vue?vue&type=script&lang=ts"
export * from "./ReceiptPrinters.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__